import { GtmInteractor } from '../gtmInteractor';

enum UC_EVENTS {
  'ACCEPT_ALL' = 'uc_accept_cookies',
  'OPEN_SEETINGS' = 'uc_settings',
  'SAVE_SETTINGS' = 'uc_save_settings',
}

enum UC_LAYER {
  'FIRST' = 'primary',
  'SECOND' = 'secondary',
}

enum UC_BUTTON_TYPE {
  'CTA' = 'cta',
  'CLOSE' = 'close',
}

export const ucAcceptedAllOnFirstLayer = (gtm: GtmInteractor) => (): void => {
  return gtm.push({
    event: UC_EVENTS.ACCEPT_ALL,
    uc_layer: UC_LAYER.FIRST,
    button_type: UC_BUTTON_TYPE.CTA,
  });
};

export const ucCloseAndAcceptedAllOnFirstLayer = (gtm: GtmInteractor) => (): void => {
  return gtm.push({
    event: UC_EVENTS.ACCEPT_ALL,
    uc_layer: UC_LAYER.FIRST,
    button_type: UC_BUTTON_TYPE.CLOSE,
  });
};
export const ucAcceptedAllOnSecondlayer = (gtm: GtmInteractor) => (): void => {
  return gtm.push({
    event: UC_EVENTS.ACCEPT_ALL,
    uc_layer: UC_LAYER.SECOND,
    button_type: UC_BUTTON_TYPE.CTA,
  });
};

export const ucCloseAndAcceptedAllOnSecondLayer = (gtm: GtmInteractor) => (): void => {
  return gtm.push({
    event: UC_EVENTS.ACCEPT_ALL,
    uc_layer: UC_LAYER.SECOND,
    button_type: UC_BUTTON_TYPE.CLOSE,
  });
};

export const ucSettingsOpened = (gtm: GtmInteractor) => (): void => {
  return gtm.push({
    event: UC_EVENTS.OPEN_SEETINGS,
    uc_layer: UC_LAYER.FIRST,
    button_type: UC_BUTTON_TYPE.CTA,
  });
};

export const ucSettingsSaved = (gtm: GtmInteractor) => (): void => {
  return gtm.push({
    event: UC_EVENTS.SAVE_SETTINGS,
    uc_layer: UC_LAYER.SECOND,
    button_type: UC_BUTTON_TYPE.CTA,
  });
};
